import React from 'react';
import SettingsLayout from './SettingsLayout';
import AIVisualSettings from '../../components/ai-entity/AIVisualSettings';

export default function SettingsAIAssistantPage() {
    return (
        <SettingsLayout title="AI Assistant" description="Configure your AI assistant's appearance and voice">
            <AIVisualSettings />
        </SettingsLayout>
    );
}
